import { createSelector } from '@ngrx/store';

import { getSubscriptionState } from './main.selectors';

export const getPendingDowngrade = createSelector(
  getSubscriptionState,
  (state) => state?.pendingOrganisationDowngrade || state?.pendingUserDowngrade
);

export const getPendingOrganisationDowngrade = createSelector(getSubscriptionState, (state) => state?.pendingOrganisationDowngrade);

export const isPendingOrganisationDowngrade = createSelector(getSubscriptionState, (state) => !!state?.pendingOrganisationDowngrade);

export const getPendingBillingCycleChange = createSelector(getSubscriptionState, (state) => state?.pendingBillingCycleChange);

export const getBillingCycle = createSelector(getSubscriptionState, (state) => state?.billingCycle);

export const getPrices = createSelector(getSubscriptionState, (state) => ({
  subscriptionPrice: state?.listingPrice?.priceWithoutVat || 0,
  subscriptionCost: state?.subscriptionCost?.priceWithoutVat || 0,
  subscriptionCredits: state?.referralCredits?.priceWithoutVat || 0,
}));

export const getRenewalDate = createSelector(getSubscriptionState, (state) => state?.renewalDate);
